import {
    createContext,
    useContext
} from 'react';

import {
    type AppAuth
} from './types';

const AppAuthContext = createContext<AppAuth | undefined>(undefined);

export const useAppAuth = (): AppAuth => {
    const appAuthContext = useContext(AppAuthContext);

    if (!appAuthContext) {
        throw new Error('useAppAuth must be used within CognitoAppAuthProvider');
    }

    return appAuthContext;
};

export default AppAuthContext;
